import { library } from "@fortawesome/fontawesome-svg-core";
import ReactDOM from "react-dom";
import React from "react";
import App from "./App";

import {
  faCheckCircle,
  faCreditCard,
  faEnvelope,
  faExclamationTriangle,
  faGlobe,
  faPen,
  faPlus,
  faSearch,
  faSignOutAlt,
  faTimes,
  faTimesCircle,
  faTrash,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";

import "./styles/index.scss";

// Font Awesome React Component
library.add(
  faPlus,
  faSignOutAlt,
  faCreditCard,
  faUserCircle,
  faTimes,
  faPen,
  faTrash,
  faCheckCircle,
  faTimesCircle,
  faEnvelope,
  faGlobe,
  faSearch,
  faExclamationTriangle
);

// Debugging
ReactDOM.render(<App />, document.getElementById("root"));
